module.exports = __webpack_public_path__ + "static/media/charcoal.fdf6f6f8.jpg";